import { createAction } from 'redux-actions'
import {
  getActiveWorkspace,
  getSourceSettingById,
  getMetadataByTypeAndId,
  getSourceStatsData
} from 'selectors'
import getProp from '@f/get-prop'
import {getSourceStatus} from 'lib/utils/sources'

export const SET_SOURCES_LIST_SETTINGS = 'SET_SOURCES_LIST_SETTINGS'
export const setSourcesListSettings = createAction(SET_SOURCES_LIST_SETTINGS)

function getSourceTrackingData (state, sourceId) {
  const workspace = getActiveWorkspace(state)
  const sourceSetting = getSourceSettingById(state, workspace.slug, sourceId).data
  const sourceMetadata = getMetadataByTypeAndId(state, 'source', sourceSetting.sourceId)

  const sourceStats = getSourceStatsData(state, workspace.slug) || {}
  const isThirdParty = sourceMetadata.type === 'third-party'
  const hasRecentlySentData = getProp(`${sourceSetting.id}.hasRecentlySentData`, sourceStats)
  const status = getSourceStatus(sourceSetting, hasRecentlySentData, isThirdParty)

  return {
    workspace_id: workspace.id,
    workspace_slug: workspace.slug,
    source_id: sourceSetting.id,
    source_slug: sourceSetting.slug,
    source_name: sourceSetting.name,
    source_type: sourceMetadata.type,
    source_metadata_slug: sourceMetadata.slug,
    source_metadata_category: sourceMetadata.category,
    source_status: status
  }
}

export function trackSourceCardPopoverOpened (sourceId, type) {
  return function (dispatch, getState) {
    const state = getState()

    window.analytics.track('Source Card Popover Opened', {
      ...getSourceTrackingData(state, sourceId),
      popover_type: type
    })
  }
}

export function trackSourceCardClicked (sourceId) {
  return function (dispatch, getState) {
    const state = getState()

    window.analytics.track('Source Card Clicked', {
      ...getSourceTrackingData(state, sourceId)
    })
  }
}

export function trackSourceCardLinkClicked (sourceId, text) {
  return function (dispatch, getState) {
    const state = getState()

    window.analytics.track('Source Card Link Clicked', {
      ...getSourceTrackingData(state, sourceId),
      link_text: text
    })
  }
}

export function trackSourcesSearched (value) {
  return function (dispatch, getState) {
    const state = getState()
    const workspace = getActiveWorkspace(state)

    window.analytics.track('Sources Searched', {
      workspace_id: workspace.id,
      workspace_slug: workspace.slug,
      term: value
    })
  }
}

export function trackSourcesFiltered (value) {
  return function (dispatch, getState) {
    const state = getState()
    const workspace = getActiveWorkspace(state)

    window.analytics.track('Sources Filtered', {
      workspace_id: workspace.id,
      workspace_slug: workspace.slug,
      filter_by: value
    })
  }
}

export function trackSourcesSorted (value) {
  return function (dispatch, getState) {
    const state = getState()
    const workspace = getActiveWorkspace(state)

    window.analytics.track('Sources Sorted', {
      workspace_id: workspace.id,
      workspace_slug: workspace.slug,
      sort_by: value
    })
  }
}



// WEBPACK FOOTER //
// ./actions/sources-list.js